import { ApiBase } from '@bymason/api-base';
import { ConnectivityMetadataModel, DashboardMetadataModel } from './types';

export * from './types';

class Metadata extends ApiBase {
  private static instance: Metadata;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A Metadata instance
   */
  public static getInstance(): Metadata {
    if (!Metadata.instance) {
      Metadata.instance = new Metadata();
    }

    return Metadata.instance;
  }

  /**
   * Gets metadata list.
   * @param options metadata required to get metadata.
   * @param clientToken token required for proper authorization.
   * @returns either void or a pageable structure that includes metadata.
   */
  public async getDashboardMetadata(clientToken: string) {
    const url = this.getEndpointTemplate('metadata/fleet');

    const dataResponse = await this.callJsonEndpoint<DashboardMetadataModel>({
      clientToken,
      errorOn404: true,
      method: 'GET',
      url,
    });

    return dataResponse;
  }

  /**
   * Gets connectivity metadata.
   * @param options metadata required to get metadata.
   * @param clientToken token required for proper authorization.
   * @returns either void or a pageable structure that includes metadata.
   */
  public async getConnectivityMetadata(clientToken: string) {
    const url = this.getEndpointTemplate('metadata/connectivity');

    const dataResponse = await this.callJsonEndpoint<ConnectivityMetadataModel>({
      clientToken,
      errorOn404: true,
      method: 'GET',
      url,
    });

    return dataResponse;
  }
}

export const metadataClient = Metadata.getInstance();
